<template>
  <div class="loading">
    <h1>Mimi Sound Personalization demo</h1>
    <br>
    <p>Once all resources are loaded click 'Next'.</p>
    <br>
    <button class="green" :disabled="!isLoadingComplete" @click="$emit('update_gain', gain_delta); $emit('next')">
      next
    </button>
    <br>
    <br>
    <h4>Loaded {{ loaded_audio }} / {{ total_audio }} AUDIO resources</h4>
    <h4>Loaded {{ loaded_video }} / {{ total_video }} VIDEO resources</h4>
    <br><br><br>
    <p class="info"><i> Please note, that the following audio <b>only simulates</b> hearing ability and the Mimi restoration effect. To try out Mimi Sound Personalization <b>tailored to your unique hearing and preferences</b>, please <b>request</b> from a Mimi team member an <b>SDK demo</b> or one of our <b>partners' integrations.</b></i></p>

    <!-- <div class="slidecontainer"> -->
      <!-- <br>
      <br>
      <input type="range" min="0" max="6" v-model="gain_delta">
      <h3>ON / OFF delta = {{ gain_delta }} dB</h3>
      <br>
      <br>
      If this is not being served over HTTPS ^ (look up)
      It will NOT have installed properly as an app on iOS!! -->

    <!-- </div> -->
  </div>
</template>

<script>
export default {
  name: 'Loading',
  emits: [
    "next",
    "update_gain"
  ],
  props: [
    "total_audio",
    "loaded_audio",
    "total_video",
    "loaded_video",
  ],
  data() {
    return {
      gain_delta: 0
    }    
  },
  computed: {
    isLoadingComplete() {
      return this.total_audio + this.total_video == this.loaded_audio + this.loaded_video;
    }
  },
}
</script>

<style>
div.loading {
  padding: 2rem;
  font-size: 1.25rem;
  line-height: 1.75rem;
  color: #898989;
  font-family: 'MontblancType-Regular';
}

p.info {
  max-width: 600px;
}
</style>